import { IOrder } from '../useOrders/orderHistory.interface';

export const useOrdersTableBody = () => {
  const formatDate = (date: string) => {
    return date.replaceAll('/', '-');
  };

  const order_params = (order: IOrder) => {
    return `${order.purchaseOrderId}/${order.productId}/${formatDate(order.deliveryDate)}/${order.branchId}`;
  };

  const shouldHideColumn = (key: string) => {
    if (key === 'branchId' || key === 'deliveryDateOrigin' || key === '__typename' || key === 'totalRows') {
      return true;
    }
    return false;
  };

  return { order_params, shouldHideColumn };
};
